import { useCxt } from "./StructureProvider";
import PropTypes from "prop-types";
import { useState, useRef, useEffect } from "react";
import teamList from "./teamList.json";
import cloneDeep from "lodash/cloneDeep";
import styles from "./Draw.module.css";
import global_styles from "./global.module.css";
import classNames from "classnames";

function generateBracket(size) {
  const ret = [];

  for (let i = 0; i < size; i++) {
    ret.push([]);
  }

  return ret;
}

function getPool(leagueStructure, stage, work, range) {
	// console.log("[getPool] start", leagueStructure, stage, work, range);
	return leagueStructure[stage].works[work+1].games.slice(range[0]/2, range[1]/2).flatMap((game) => {
		// console.log("[getPool]", game)
		// To Do: str to team
		function strToTeam(newGame, teamN){
			const info = newGame[teamN];
			if(typeof(info) === 'number') return info;
			
			const stageM = info[0] * 1;
			const workM = info[1] * 1;
			const gameM = info[2] * 1;
			const isWin = info[3] === 'W';

			const oldGame = leagueStructure[stageM].works[workM].games[gameM];
			if(oldGame.score === "0:0") return -1;

			return (((oldGame.score[0] * 1) > (oldGame.score[2] * 1)) === isWin) ? oldGame.team1 : oldGame.team2;	
		}
		return [strToTeam(game, "team1"), strToTeam(game, "team2")];
	}).sort(() => Math.random() - 0.5);
}

function SingleDraw({ stage, work, rule, range, callBack }) {
	const bracketN = (range[1] - range[0]) / 2;
	const [bracket, setBracket] = useState(generateBracket(bracketN));
	
	const {leagueStructure, updateLeagueStructure} = useCxt();
	const tmpStructure = cloneDeep(leagueStructure);
	const [pool, setPool] = useState(getPool(leagueStructure, stage, work, range));
	
	const isMounted = useRef(0);
	
	useEffect(() => {
		if(isMounted.current){
			setBracket(generateBracket(bracketN));
			setPool(getPool(leagueStructure, stage, work, range));
		} else isMounted.current = 1;
	}, [leagueStructure, stage, work, range, bracketN]);
	
	const works = leagueStructure[stage].works.filter((workInput, idx) => 
																										(workInput.type === "Round" && idx < work));
	
	function isRematch(tmpBracket, bracketI) {
		const teams = tmpBracket[bracketI];
		for(let i = 0; i < works.length; i++) {
			if(works[i].games.filter((gameInput) =>
															 (gameInput.team1 === teams[0] && gameInput.team2 === teams[1]) || 
															 (gameInput.team1 === teams[1] && gameInput.team2 === teams[0])
															).length !== 0) return true;
		}
		return false;
	}

	function checkPossibleSwiss(tmpBracket, tmpPool) {
		if(tmpPool.length === 0) return true;
		const drawnTeam = tmpPool.pop();

		for (let bracketI = 0; bracketI < bracketN; bracketI++) {
			if(tmpBracket[bracketI].length === 2) continue;
			tmpBracket[bracketI].push(drawnTeam);
			if(tmpBracket[bracketI].length === 2 && isRematch(tmpBracket, bracketI))
				tmpBracket[bracketI].pop();
			else if(checkPossibleSwiss(tmpBracket, tmpPool)) {
				tmpBracket[bracketI].pop();
				tmpPool.push(drawnTeam);
				return true;
			}
			else tmpBracket[bracketI].pop();
		}
		console.log("[checkPossibleSwiss] false.", tmpBracket, tmpPool, drawnTeam);
		tmpPool.push(drawnTeam);
		return false;
	}
	function checkPossibleOnlySeed(tmpBracket, tmpPool) {
		return true;
	}

	function drawTeam(checkPossible, tmpBracket, tmpPool) {
		const idx = Math.floor(Math.random() * tmpPool.length);
		const drawnTeam = tmpPool.splice(idx, 1)[0];
		console.log(tmpPool, drawnTeam, tmpBracket);

		for (let bracketI = 0; bracketI < bracketN; bracketI++) {
			if(tmpBracket[bracketI].length === 2) continue;
			tmpBracket[bracketI].push(drawnTeam);
			console.log(tmpPool, drawnTeam, tmpBracket);
			if(tmpBracket[bracketI].length === 2 && isRematch(tmpBracket, bracketI)) {
				tmpBracket[bracketI].pop();
				continue;
			}
			if(checkPossible(tmpBracket, tmpPool)) return console.log(tmpPool, drawnTeam, tmpBracket);
			tmpBracket[bracketI].pop();
			console.log("[drawTeam] checkPossible returns false.");
		}
		console.log("[drawTeam] something goes wrong.");
	}
	
	function drawTeamWrapper() {
		const checkPossible = "Swiss" ? checkPossibleSwiss : checkPossibleOnlySeed;
		const tmpPool = cloneDeep(pool);
		const tmpBracket = cloneDeep(bracket);
		drawTeam(checkPossible, tmpBracket, tmpPool);
		
		console.log(tmpPool, tmpBracket);
		
		setPool(tmpPool);
		setBracket(tmpBracket);
	}
	
	function endDrawTeam() {
		const checkPossible = "Swiss" ? checkPossibleSwiss : checkPossibleOnlySeed;
		const tmpPool = cloneDeep(pool);
		const tmpBracket = cloneDeep(bracket);
		while(tmpPool.length !== 0) drawTeam(checkPossible, tmpBracket, tmpPool);
		
		setPool([]);
		setBracket(tmpBracket);
	}
	
	function doneFunction() {
		for(let i = 0; i < bracketN; i++){
			const game = tmpStructure[stage].works[work+1].games[range[0]/2+i];
			game.team1 = bracket[i][0];
			game.team2 = bracket[i][1];
			// console.log("[doneFunction] ", bracket, game);
		}
		updateLeagueStructure(tmpStructure);
		callBack();
	}
	console.log("pool", pool, "bracket", bracket);
	
	// To Do: make animation.

	return(
		<div>
			<div className={global_styles.main_container}>
				<div className={styles.pool_box}>
					<h3>Pool</h3>
					<div className={styles.pool}>
						{pool.map((team) => {
							return <div className={classNames([styles.team, styles.pool_team])} key={["pool", team]}>{teamList[team].team}</div>;
						})}
					</div>
				</div>
				<div>
					<h3>Bracket</h3>
					{
						Array.from({ length: bracketN }, (_, index) => index).map((bracketI) => {
							return (
								<table className={styles.bracket_table} key={["bracket", bracketI]}>
									<thead align="center">
										<tr>
											<th>
												<h4>Bracket {String.fromCharCode(65 + bracketI)}</h4>
											</th>
										</tr>
									</thead>
									<tbody>
										{
											bracket[bracketI] !== undefined ?
											<>
												{
													bracket[bracketI][0] !== undefined ?
													<tr className={classNames([styles.team, styles.bracket_team, styles.first_team])} key={["team1", bracketI]}><td>{teamList[bracket[bracketI][0]].team}</td></tr>
													: <tr className={styles.first_team}><td></td></tr>
												}
												{
													bracket[bracketI][1] !== undefined ?
													<tr className={classNames([styles.team, styles.bracket_team])} key={["team2", bracketI]}><td>{teamList[bracket[bracketI][1]].team}</td></tr>
													: <tr><td></td></tr>
												}
											</> : null
										}
									</tbody>
								</table>
							)
						})
					}
				</div>
			</div>
			<div className={global_styles.button_container}>
				{
					pool.length === 0 ? 
					<button onClick={doneFunction}>click!</button>	:
					<>
						<button onClick={drawTeamWrapper}>
							draw!
						</button>
						<button onClick={endDrawTeam}>
							end draw!
						</button>
					</>
				}
			</div>
		</div>
	);	
}

SingleDraw.propTypes = {
	stage: PropTypes.number,
	work: PropTypes.number,
	rule: PropTypes.string,
	range: PropTypes.array,
	callBack: PropTypes.func,
}

export default SingleDraw;